import { render, staticRenderFns } from "./COAAddMultiCurrencyAllocationModal.vue?vue&type=template&id=0d91c635&scoped=true&"
import script from "./COAAddMultiCurrencyAllocationModal.vue?vue&type=script&lang=js&"
export * from "./COAAddMultiCurrencyAllocationModal.vue?vue&type=script&lang=js&"
import style0 from "./COAAddMultiCurrencyAllocationModal.vue?vue&type=style&index=0&id=0d91c635&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d91c635",
  null
  
)

export default component.exports